const removeUnderscoreMetaFromResponse = (data) => {
  if (data === null) return data;

  if (Array.isArray(data)) {
    return data.map((item) => removeUnderscoreMetaFromResponse(item));
  }

  if (typeof data === 'object' && !(data instanceof Date)) {
    const newObj = {};
    for (const [key, value] of Object.entries(data)) {
      if (key !== '__meta') {
        newObj[key] = typeof value === 'object' ? removeUnderscoreMetaFromResponse(value) : value;
      }
    }
    return newObj;
  }

  // For all other types (string, number, boolean, etc), return as is
  return data;
};

export default removeUnderscoreMetaFromResponse;
